import { settings as raySettings } from '@wework/ray-core';
import WeGlide from 'client/javascript/we_glide/we_glide';
import { varsFromServer } from 'client/javascript/client_side_injection_vars';
import { logError } from 'client/javascript/util/logger';

const CARDS_ARTICLES_SLIDERS = '.cards-articles-gallery';

export const cardsArticlesSliderOptions = {
  perView: 3,
  bound: true,
  direction: varsFromServer.textDirection,
  sliderActiveClass: 'cards-articles-slider--active',
  breakpoints: {
    [raySettings.breakpointsInPixels.tablet]: {
      perView: 1,
      peek: {
        before: 0,
        after: 10
      },
      gap: 16
    },
    [raySettings.breakpointsInPixels.desktop]: {
      gap: 24,
      peek: {
        before: 0,
        after: 0
      },
      perView: 2
    }
  }
};

export function setupCardsArticlesGallery() {
  try {
    const sliderElements = document.querySelectorAll(CARDS_ARTICLES_SLIDERS);
    sliderElements.forEach((element, index) => {
      const glide = new WeGlide(`${CARDS_ARTICLES_SLIDERS}:nth-child(1n + ${index})`, cardsArticlesSliderOptions);
      glide.mount();
    });
  } catch (error) {
    logError(`[Shared modules] setupCardsArticlesGallery failed: ${error.message}`, error);
  }
}
